// =============================================================================
//  CONTRACT ADDRESSES  —  fill in per network.
//  Addresses are keyed by ACTIVE_NETWORK so you only flip network.js.
// =============================================================================
import { ACTIVE_NETWORK } from "./network";
import NexauraAbi from "./abi.json";
import UsdtAbi from "./usdtAbi.json";

const ADDRESSES = {
  MAINNET: {
    // 🔻 REPLACE WITH DEPLOYED MAINNET ADDRESSES 🔻
    nexaura: "0xBFdFd298941bbEab55fEb27E01A518c5D8493EbD", // PLACEHOLDER
    usdt: "0x55d398326f99059fF775485246999027B3197955", // BSC mainnet USDT (BEP-20)
    // Block the Nexaura contract was deployed at. Activity scan starts here.
    deployBlock: 107595862, // 🔻 SET TO MAINNET DEPLOY BLOCK 🔻
  },
  TESTNET: {
    // 🔻 REPLACE WITH DEPLOYED TESTNET ADDRESSES 🔻
    nexaura: "0xe4b99fd984fa8dab88b37a3232ca799a3cc46c94", // PLACEHOLDER
    usdt: "0x2620D043772DdE2a4B5cfBB807Aa3ebd678DD1DC", // PLACEHOLDER (your test USDT)
    // Block the Nexaura contract was deployed at. Activity scan starts here.
    deployBlock: 115691227, // 🔻 SET TO TESTNET DEPLOY BLOCK 🔻
  },
};

export const NEXAURA_ADDRESS = ADDRESSES[ACTIVE_NETWORK].nexaura;
export const USDT_ADDRESS = ADDRESSES[ACTIVE_NETWORK].usdt;
export const DEPLOY_BLOCK = ADDRESSES[ACTIVE_NETWORK].deployBlock || 0;

// Max blocks per eth_getLogs request (public BSC RPCs commonly cap ~10k–50k).
export const LOG_CHUNK = 9000;

export const NEXAURA_ABI = NexauraAbi;
export const USDT_ABI = UsdtAbi;

// USDT on BSC uses 18 decimals (BEP-20), matching the contract's packagePrices.
export const USDT_DECIMALS = 18;

// Default referrer id used by the contract when none is supplied.
export const DEFAULT_REFERRER = 100000;
